import { FiAlertTriangle, FiArrowRight, FiArrowLeft, FiArrowDown } from "react-icons/fi";
import "./ShopSafelyPanel.css";

// Order matches the real buyer journey — "Inspect"/"Complete" wording mirrors
// the actual buttons a buyer sees in the order thread (src/components/inbox/
// ThreadView.jsx: "Confirm delivery" / "Report a problem"). Escrow only ever
// releases via the buyer's own confirm-delivery action (backend/app/main.py,
// confirm_delivery) — never on a timer — so "Complete" states that directly.
const STAGES = [
  { label: "Discover",     detail: "Choose a product" },
  { label: "Checkout",     detail: "Review the order and delivery details" },
  { label: "Pay securely", detail: "Pay only through Emporia checkout" },
  { label: "Delivery",     detail: "The seller dispatches your order" },
  { label: "Inspect",      detail: "Confirm delivery or report a problem" },
  { label: "Complete",     detail: "Payment is released after you confirm delivery" },
];

const FRAUD_TIPS = [
  "Only pay through Emporia's official checkout.",
  "Before signing in or paying, check that your browser's address bar shows www.emporia.ke.",
  "Never pay a seller's personal phone number or bank account.",
  "Confirm every payment prompt shows the business name \"Emporia\" before you approve it.",
  "Emporia staff and sellers will never ask you to share your password, PIN or OTP.",
];

const ShopSafelyPanel = () => (
  <>
    <div className="ssp-diagram-wrap">
      <div className="ssp-diagram" role="list" aria-label="Emporia's 6-step purchase and delivery process">
        {STAGES.map((stage, i) => {
          const n = i + 1;
          return (
            <div key={stage.label} role="listitem" className={`ssp-node ssp-node--${n}`}>
              <div className="ssp-node-text">
                <p className="ssp-node-label">{stage.label}</p>
                <p className="ssp-node-detail">{stage.detail}</p>
              </div>
              {n < STAGES.length && (
                <span className="ssp-connector" aria-hidden="true">
                  <FiArrowRight className="ssp-arrow ssp-arrow--right" />
                  <FiArrowLeft className="ssp-arrow ssp-arrow--left" />
                  <FiArrowDown className="ssp-arrow ssp-arrow--down" />
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>

    <div className="ssp-fraud" aria-labelledby="ssp-fraud-heading">
      <div className="ssp-fraud-header">
        <FiAlertTriangle className="ssp-fraud-icon" aria-hidden="true" />
        <h3 id="ssp-fraud-heading" className="ssp-fraud-title">Protect yourself from fraud</h3>
      </div>
      <div className="ssp-fraud-list" role="list" aria-labelledby="ssp-fraud-heading">
        {FRAUD_TIPS.map((tip) => (
          <div key={tip} role="listitem" className="ssp-fraud-item">{tip}</div>
        ))}
      </div>
      <p className="ssp-fraud-closing">
        Payments made outside Emporia's official checkout are not held in escrow and cannot be protected.
      </p>
      <p className="ssp-fraud-chat-note">
        If something looks suspicious, contact us through Soko support chat.
      </p>
    </div>
  </>
);

export default ShopSafelyPanel;
